import React, { Component } from 'react';
import { QueryRenderer } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, Paper, Typography } from '@mui/material';
import { Link, Table, TableBody, TableCell, TableHead, TablePagination, TableSortLabel, TableRow } from '@mui/material';
import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';
import SearchField from '../ui/SearchField';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();

const AdminVendorSummaryQuery = graphql`
query AdminVendorSummaryQuery($vendorAccountId: UUID!, $resellerName: String, $orderBy: Int, $orderDirection: Int, $first: Int, $offset: Int) {
adminvendorsummarywithorderby(vendoraccountid: $vendorAccountId, resellername: $resellerName, orderby: $orderBy, orderdirection: $orderDirection, first: $first, offset: $offset) {
    totalCount
    nodes {
      resellerAccountName
      resellerAccountId
      registeredReseller
      appName
      subscriptionCount
      totalCharge
      averageCharge
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.background.default,
  },
  flex: {
    flex: 1,
  }
});

class AdminVendorSummary extends Component {
  state = {
    
    resellerName: '',
    orderby: 1,
    orderdir: 0,
    page: 0,
    rowsPerPage: 10,
  };

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }
  
  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  setOrderBy = (ob, dir) => {
    let thedir = dir;
    if (dir === 'asc') {
      thedir = 0;
    } else if (dir === 'desc') {
      thedir = 1;
    }
    if (thedir !== 0 && thedir !== 1) {
      thedir = 0;
    }
    this.setState({orderby: ob, orderdir: thedir, page: 0});
  }

  toggleOrder = (ob) => {
    let newDir = 0;
    if (ob === this.state.orderby) {
        if (this.state.orderdir === 0) {
            newDir = 1;
        }
    }

    this.setState({orderby: ob, orderdir: newDir, page: 0});
  } 

  render() {
    const { isAuthenticated, isAuthenticatedAppBind, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    let theResellerSearch = '';
    if (this.state.resellerName !== '')
    {
      theResellerSearch = '%' + this.state.resellerName + '%';
    } else {
      theResellerSearch = '%';
    }


    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;
  
    let totalCount = 0;

    let theDir = 'asc';
    if (this.state.orderdir === 1) {
        theDir = 'desc';
    }

    let rowCounter = 1;
     if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    } else if (isAuthenticatedAppBind()) {
      return (
        <main>
 
            <Grid container direction="row" justifyContent="flex-start">
              <Grid item>
                <SearchField
                    id="resellerName"
                    label="Search by reseller name"
                    value={this.state.resellerName}
                    onChange={this.handleChange('resellerName')}
                  />
              </Grid>
            </Grid>
            
            
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={AdminVendorSummaryQuery}
            variables={{vendorAccountId: this.props.vendorAccountId,
                        resellerName: theResellerSearch,
                        orderBy: this.state.orderby,
                        orderDirection: this.state.orderdir,
                        first: first,
                        offset: offset}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                // Determine offset information
                totalCount = props.adminvendorsummarywithorderby.totalCount;

                return ( 
                  <div style={{marginTop: '16px'}}>

                    <Paper className={classes.paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <TableSortLabel
                                          active={this.state.orderby === 1}
                                          direction={theDir}
                                          onClick={() => this.toggleOrder(1) }>
                                            Reseller name
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell>
                                        <TableSortLabel
                                          active={this.state.orderby === 2}
                                          direction={theDir}
                                          onClick={() => this.toggleOrder(2) }>
                                            Registered
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell >
                                        <TableSortLabel
                                          active={this.state.orderby === 3}
                                          direction={theDir}
                                          onClick={() => this.toggleOrder(3) }>
                                            Vendor app
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell align="right">
                                        <TableSortLabel
                                          active={this.state.orderby === 4}
                                          direction={theDir}
                                          onClick={() => this.toggleOrder(4) }>
                                            # Subscriptions
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell align="right">
                                        <TableSortLabel
                                          active={this.state.orderby === 5}
                                          direction={theDir}
                                          onClick={() => this.toggleOrder(5) }>
                                            Total charge
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell align="right">
                                        <TableSortLabel
                                          active={this.state.orderby === 6}
                                          direction={theDir}
                                          onClick={() => this.toggleOrder(6) }>
                                            Average charge
                                        </TableSortLabel>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.adminvendorsummarywithorderby.nodes.map(row => {
                                    
                                    let aUrl = "reseller?accountId=" + row.resellerAccountId;
                                    return (
                                        <TableRow key={rowCounter++}>
                                            <TableCell>
                                            <Link component="button" 
                                                  variant="body2"
                                                  className={classes.custlink}
                                                  onClick={this.goTo.bind(this, aUrl)}>
                                              { row.resellerAccountName }
                                            </Link>                                              
                                            </TableCell>
                                            <TableCell>
                                                { (row.registeredReseller === 1) ? "Yes" : "No" }
                                            </TableCell>
                                            <TableCell a>
                                                {row.appName}
                                            </TableCell>
                                            <TableCell align="right">
                                                {row.subscriptionCount}
                                            </TableCell>
                                            <TableCell align="right">
                                                { Number(row.totalCharge).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2})}
                                            </TableCell>
                                            <TableCell align="right">
                                                { Number(row.averageCharge).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2})}
                                            </TableCell>
                                            
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </Paper>

                    <div style={AppBindStyles.paginationTableFooter}>
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 50]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />                        
                    </div>
                  </div>
                )
              }
              return (
                <div>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </main>
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

AdminVendorSummary.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(AdminVendorSummary);